module.exports = __webpack_public_path__ + "img/375.4e00c6ad.jpg";